<template>
  <div class="ma-3">
    <div class="title mb-3">
      Sessions <v-icon>mdi-chevron-right</v-icon> Events settings management
    </div>

    <div
      layout="column"
      layout-align="center center"
    >
      <div
        layout="column"
        class="field-width"
      >
        <div
          layout="row"
          layout-align="start center"
          class="ml-3"
        >
          <v-text-field
            v-model="filters.keywords"
            solo
            label="Keywords"
            hide-details
            @keyup.enter="fetch"
          />
          <v-btn
            depressed
            color="primary"
            @click="fetch"
          >
            Filter
          </v-btn>
          or
          <a
            href="#"
            class="ml-2 black--text"
            @click="resetFilters"
          >Cancel</a>
        </div>

        <div>
          <v-btn
            flat
            class="mt-3"
            :to="{name: 'admin-sessions-settings-edit', params: {id: 'new'}}"
          >
            <v-icon
              left
              color="primary"
            >
              mdi-plus-box
            </v-icon>
            Add a new setting
          </v-btn>
        </div>

        <v-data-table
          :headers="headers"
          :items="settings"
          style="max-width: 1000px"
          :pagination.sync="pagination"
        >
          <template
            slot="items"
            slot-scope="{ item }"
          >
            <td>{{ item.name }}</td>
            <td layout="row">
              <v-btn
                class="mx-0"
                icon
                :to="{name: 'admin-sessions-settings-edit', params: {id: item.id}}"
              >
                <v-icon>mdi-pencil</v-icon>
              </v-btn>

              <delete-button
                :label="item.name"
                @confirm="deleteImpl(item)"
              />
            </td>
          </template>
        </v-data-table>
      </div>
    </div>
  </div>
</template>

<script>
    import Params from '@/api/params'
    import DeleteButton from "@/components/shared/DeleteButton.vue"

    export default {
        components: {DeleteButton},
        data () {
            return {
                pagination: {
                    rowsPerPage: 10
                },
                headers: [
                    { text: 'Setting', value: 'name' },
                    { text: 'Actions', sortable: false, width: "80px" }
                ],
                filters: {
                    keywords: null
                },
                settings: []
            }
        },
        mounted () {
            this.fetch();
        },
        methods: {
            fetch () {
                Params.getList('events-settings', this.filters).then(res => {
                    this.settings = res.data;
                })
            },

            resetFilters () {
                this.filters = {keywords: null};
                this.fetch();
            },

            deleteImpl (item) {
                Params.delete('events-settings', item.id).then(() => {
                    this.fetch();
                    this.$snotify.success(`The setting "${item.name}" has been deleted`)
                })
            }
        }
    }
</script>